import { BrowserRouter as Router } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';

import './styles/index.scss';
import LoadingOverlay from './components/LoadingOverlay';
import MuiTheme from './styles/mui-theme';
import RouteList from './components/Routes';
import useLoader from './context/LoaderContext';

const App = () => {
  const { isLoading } = useLoader();

  return (
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_AUTH_CLIENT_ID}>
      <ThemeProvider theme={MuiTheme}>
        <CssBaseline />
        <LoadingOverlay open={isLoading} />
        <Router>
          <RouteList />
        </Router>
      </ThemeProvider>
    </GoogleOAuthProvider>
  );
};

export default App;
